import React from "react"
import "./tiggbee-footer.css"
// import tiggbee_footer_logo from '../images/tiggbee-footer-logo.png';
import { Link } from "gatsby"

export class TiggbeeFooter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      socialLinks: [
        {
          platform: 'LinkedIn',
          link: 'https://www.linkedin.com/company/tiggbee',
          iconURL: '/social-LinkedIn.png',
          width: '25px'
        },
        {
          platform: 'Instagram',
          link: 'https://www.instagram.com/tiggbee',
          iconURL: '/social-Instagram.png',
          width: '22px'
        },
        {
          platform: 'Facebook',
          link: 'https://www.facebook.com/tiggbeellc',
          iconURL: '/social-Facebook.png',
          width: '26px'
        },
        {
          platform: 'Youtube',
          link: 'https://www.youtube.com/@tiggbee?sub_confirmation=1',
          iconURL: '/social-Youtube.png',
          width: '26px'
        }
      ]
    }
  }

  render() {
    const { socialLinks } = this.state;
    const html = (
      <>
        <div className="container-fluid footer-containter">
          <div className="row">
            <div className="col-md-4 footer-col">
              <div
                className="footer-tiggbee-logo-container"
                style={{ marginTop: "28px" }}
              >
                <Link to="/" className="footer-tiggbee-logo-link">
                  <img alt="" src={"/tiggbee-footer-logo.png"} />
                </Link>
              </div>
            </div>
            <div className="col-md-4 footer-col">
              <div className="footer-link footer-horizon-link-row">
                <div>
                  <Link to="/contact-us-page/">Contact us</Link>
                </div>
                <div>
                  <a href="https://event.tiggbee.com/">Sign in</a>
                </div>
                <div className="footer-hr"></div>
              </div>
              <div className="footer-sublink footer-horizon-link-row">
                <div>
                  <Link to="/privacy-policy-page">Privacy Policy</Link>
                </div>
                <div>
                  <Link to="/terms-and-conditions-page">
                    Terms & Conditions
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-4 footer-create-accout-col">
              <div className="footer-create-account-button-container">
                <a href="https://event.tiggbee.com/authentication/createaccount">
                  Create account
                </a>
                <div>
                  {socialLinks.map(social => (
                    <div>
                      <a
                        href={social.link}
                        target="_blank"
                      >
                        <img
                          alt={social.platform}
                          src={social.iconURL}
                          width={social.width}
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
    return html
  }
}
